import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { galleryCategories } from '../data/gallery';
export function Projects() {
  return <section className="w-full overflow-hidden bg-shell py-16 lg:py-24" data-id="element-166" data-mp="fxlyu2ra9gfh">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-167" data-mp="ulqgd3elnlwo">
        <SectionHeading overline="Creaciones reales" size="lg" title={<>
              Todo lo que podés crear con{' '}
              <span className="italic text-terracotta-500" data-id="element-169" data-mp="13kkbepca8484">esta guía</span>
            </>} data-id="element-168" data-mp="ptyrqyf07q96" />

        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-5" data-id="element-170" data-mp="yms8l0a3mxp5">
          {galleryCategories.map(category => <figure key={category.name} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gold-200/60 bg-cream" data-id="element-171" data-mp="1dk2u72gghjyl">
              <div className="overflow-hidden" data-id="element-172" data-mp="18kzmfa93czmx">
                <img src={category.image} alt={category.name} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.04]" data-id="element-173" data-mp="3famk639b9w1f" />
              </div>
              <figcaption className="px-3 py-4 text-center sm:px-6 sm:py-6" data-id="element-174" data-mp="1xcat9n54gpgq">
                <p className="font-serif text-[1.1rem] leading-tight text-sage-800 sm:text-[1.5rem]" data-id="element-175" data-mp="1xa7tibe63hyt">
                  {category.name}
                </p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}